const video = [
  {
    title: '【一起撩科技X一日系列07】 百香果跟棒球一樣大！用AI無毒栽種',
    thumbnail: require('assets/images/home/video-thumbnails/1.jpg'),
    src: 'https://www.youtube.com/embed/Q2gIJVR-1eM?si=feOYpy798oNVYQl0'
  },
  {
    title: '【一起撩科技X一日系列05】讓棒球員訓練效果大升級！ 「EMG智慧褲」化身肌肉透視鏡',
    thumbnail: require('assets/images/home/video-thumbnails/2.jpg'),
    src: 'https://www.youtube.com/embed/fG74o8873hA?si=TKLFAtgJOEYEgowc'
  },
  {
    title: '【科技哪裡趣X科技報報】EP05 會關心毛孩的床墊？睡覺也能監測健康！FT. 劉方慈',
    thumbnail: require('assets/images/home/video-thumbnails/3.jpg'),
    src: 'https://www.youtube.com/embed/KnUBA7Z_uVI?si=hSlcTGWoFQ3pkBiT'
  },
  {
    title: '【科技哪裡趣X科技報報】EP03 全循環「低碳水泥」環保逆襲！甩掉90%碳排！FT.劉方慈',
    thumbnail: require('assets/images/home/video-thumbnails/4.jpg'),
    src: 'https://www.youtube.com/embed/jPExA0WfJVU?si=19LZMLUUJaMROg3Z'
  },
  {
    title: '【科技哪裡趣X科技報報】EP02 特斯拉剎車零件守護者！AI聽力博士找「內傷」FT.劉方慈',
    thumbnail: require('assets/images/home/video-thumbnails/5.jpg'),
    src: 'https://www.youtube.com/embed/vnvQZPOeTS0?si=BoF-KBskJcmg55dP'
  },
  {
    title: 'AI低碳無機聚合混凝土技術－2024全球百大科技研發獎獲獎',
    thumbnail: require('assets/images/home/video-thumbnails/6.jpg'),
    src: 'https://www.youtube.com/embed/G4vkizcLV2A?si=8Flw8q8_P6FYUlVT'
  },
  {
    title: '《ITRI NEWS》人類與AI誰更快？ITRI特派員體驗黑面琵鷺辨識挑戰',
    thumbnail: require('assets/images/home/video-thumbnails/7.jpg'),
    src: 'https://www.youtube.com/embed/BKeqLpsiz5s?si=XT2gaU8FgMI-cWwv'
  },
  {
    title: '鈑金翹曲AI技術',
    thumbnail: require('assets/images/home/video-thumbnails/8.jpg'),
    src: 'https://www.youtube.com/embed/HbkEoiFa1nA?si=rPy1dpY_jAPAN_dm'
  },
  {
    title: 'AI音頻非破壞檢測技術',
    thumbnail: require('assets/images/home/video-thumbnails/9.jpg'),
    src: 'https://www.youtube.com/embed/YnXmpFyLLPc?si=RJJWd2OcnxJwiO9X'
  },
]

export default video;